(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["vtr-promotion-callout"] && !Shopify.designMode) return;
  try {
    (function () {
  if (!window.customElements || customElements.get('vtr-promotion-callout')) return;

  class VtrPromotionCallout extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.hidden = true;
      this.root = this.closest('.product--outer');
      this.priceLine = this.querySelector('[data-vtr-promo-price]');
      this.amount = this.querySelector('[data-vtr-promo-amount]');
      this.percent = Number(this.dataset.percent);
      this.starts = Number(this.dataset.starts) * 1000;
      this.ends = Number(this.dataset.ends) * 1000;
      this.sequence = (this.sequence || 0) + 1;
      this.clockSequence = (this.clockSequence || 0) + 1;
      this.onVariant = event => {
        if (String(event.detail && event.detail.product && event.detail.product.id) !== this.dataset.productId) return;
        this.sequence += 1;
        this.variant = event.detail.variant || null;
        this.render();
      };
      this.onChange = () => this.readVariant();
      this.onVisible = () => {
        this.hidden = true;
        if (document.visibilityState !== 'hidden') this.refreshClock();
      };
      this.onReady = () => this.initialize();
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', this.onReady, { once: true });
      else this.initialize();
    }

    async initialize() {
      if (!this.isConnected || !this.root) return;
      this.selector = this.root.querySelector('[data-variant-selection]');
      if (!this.selector || ![40, 50].includes(this.percent) || !Number.isFinite(this.starts) || !Number.isFinite(this.ends)) return;
      this.selector.addEventListener('variant-change', this.onVariant);
      this.root.addEventListener('change', this.onChange, true);
      document.addEventListener('visibilitychange', this.onVisible);
      window.addEventListener('pageshow', this.onVisible);
      this.refreshClock();
      await customElements.whenDefined('variant-selection');
      if (this.isConnected) this.readVariant();
    }

    async readVariant() {
      const sequence = ++this.sequence;
      this.hidden = true;
      try {
        const variant = await this.selector.getVariant();
        if (!this.isConnected || sequence !== this.sequence) return;
        this.variant = variant || null;
        this.render();
      } catch (error) {
        if (this.isConnected && sequence === this.sequence) {
          this.variant = null;
          this.hidden = true;
        }
      }
    }

    async refreshClock() {
      const sequence = ++this.clockSequence;
      this.clock = null;
      this.hidden = true;
      if (this.clockController) this.clockController.abort();
      const controller = new AbortController();
      this.clockController = controller;
      const timeout = setTimeout(() => controller.abort(), 8000);
      const requestedAt = performance.now();
      try {
        const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
        const url = new URL(root + 'cart.js', window.location.origin);
        url.searchParams.set('vtr_promotion_clock', String(Date.now()) + '-' + String(sequence));
        const response = await fetch(url.toString(), { cache: 'no-store', credentials: 'same-origin', headers: { Accept: 'application/json' }, signal: controller.signal });
        const serverTime = Date.parse(response.headers.get('Date'));
        if (!response.ok || !Number.isFinite(serverTime)) throw new Error('Clock unavailable');
        const cart = await response.json();
        if (!this.isConnected || sequence !== this.clockSequence) return;
        const receivedAt = performance.now();
        this.clock = { lower: serverTime, upper: serverTime + 1000 + receivedAt - requestedAt, receivedAt: receivedAt, currency: cart.currency };
        this.render();
      } catch (error) {
        if (sequence === this.clockSequence) {
          this.clock = null;
          this.hidden = true;
        }
      } finally {
        clearTimeout(timeout);
      }
    }

    hasSellingPlan() {
      return Array.from(this.root.querySelectorAll('[name="selling_plan"]')).some(input => {
        if ((input.type === 'radio' || input.type === 'checkbox') && !input.checked) return false;
        return Boolean(input.value);
      });
    }

    render() {
      clearTimeout(this.expiryTimer);
      this.hidden = true;
      this.priceLine.hidden = true;
      if (!this.isConnected || !this.clock || !this.variant || this.variant.available !== true || this.hasSellingPlan()) return;
      const elapsed = performance.now() - this.clock.receivedAt;
      const lowerNow = this.clock.lower + elapsed;
      const upperNow = this.clock.upper + elapsed;
      if (elapsed < 0 || lowerNow < this.starts || upperNow >= this.ends || document.visibilityState === 'hidden') return;
      const currency = this.dataset.currency;
      const activeCurrency = window.Shopify && window.Shopify.currency && window.Shopify.currency.active;
      if (!currency || this.clock.currency !== currency || (activeCurrency && activeCurrency !== currency)) return;
      const price = Number(this.variant.price);
      if (!Number.isSafeInteger(price) || price < 0) return;
      if (currency === 'USD') {
        const payable = price - Math.floor(price * this.percent / 100);
        try {
          this.amount.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: 'USD' }).format(payable / 100);
          this.priceLine.hidden = false;
        } catch (error) {
          this.priceLine.hidden = true;
        }
      }
      this.hidden = false;
      this.expiryTimer = setTimeout(() => this.render(), Math.max(1, Math.min(this.ends - upperNow, 30000)));
    }

    disconnectedCallback() {
      this.hidden = true;
      this.sequence += 1;
      this.clockSequence += 1;
      clearTimeout(this.expiryTimer);
      if (this.clockController) this.clockController.abort();
      document.removeEventListener('DOMContentLoaded', this.onReady);
      document.removeEventListener('visibilitychange', this.onVisible);
      window.removeEventListener('pageshow', this.onVisible);
      if (this.selector) this.selector.removeEventListener('variant-change', this.onVariant);
      if (this.root) this.root.removeEventListener('change', this.onChange, true);
      this.initialized = false;
    }
  }

  customElements.define('vtr-promotion-callout', VtrPromotionCallout);
}());
  } catch(e) { console.error(e); }
})();

})();
